import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import type { Constructor } from '@whispli/types';

export class __ReportStatus extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly name!: string;
  /**
   * @deprecated For backwards-compatibility only. Use isDefault
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_default!: boolean;

  @Expose({groups: ['client']})
  public get isDefault() {
    return this.is_default
  }

  public set isDefault(value) {
    this.is_default = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use isEndType
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_end_type!: boolean;

  @Expose({groups: ['client']})
  public get isEndType() {
    return this.is_end_type
  }

  public set isEndType(value) {
    this.is_end_type = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Number)
  public readonly order!: number;
  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly color!: string | null;
  @Expose({ groups: ['client', 'server'] })
  @Type(() => Boolean)
  public readonly protected!: boolean;
  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private created_at!: string;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private updated_at!: string;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use deletedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private deleted_at!: string | null;

  @Expose({groups: ['client']})
  public get deletedAt() {
    return this.deleted_at
  }

  public set deletedAt(value) {
    this.deleted_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use archivedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private archived_at!: string | null;

  @Expose({groups: ['client']})
  public get archivedAt() {
    return this.archived_at
  }

  public set archivedAt(value) {
    this.archived_at = value
  }
}
export type ReportStatus = Omit<__ReportStatus, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'is_default' | 'is_end_type' | 'created_at' | 'updated_at' | 'deleted_at' | 'archived_at'>
export const ReportStatus = __ReportStatus as any as Constructor<ReportStatus>
